import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "counter"]
  static values = { max: { type: Number, default: 1000 } }

  connect() {
    this.update()
  }

  update() {
    const remaining = this.maxValue - this.inputTarget.value.length

    this.counterTarget.textContent = `${remaining} / ${this.maxValue}`

    if (remaining < 0) {
      this.counterTarget.classList.add("text-red-500")
      this.counterTarget.classList.remove("text-gray-400")
    } else {
      this.counterTarget.classList.remove("text-red-500")
      this.counterTarget.classList.add("text-gray-400")
    }
  }
}
